import { HStack } from '@chakra-ui/react';
import NavButton from '../NavButton';

const DesktopNavigation = () => { 
    return (
        <HStack>
            <NavButton to='/'>
                HOME
            </NavButton>
            <NavButton to='/summary'>
                SUMMARY
            </NavButton>
            <NavButton to='/documents'>
                DOCUMENTS
            </NavButton>
            <NavButton to='/plantlist'>
                PLANT LIST
            </NavButton>
            <NavButton to='/contact'>
                CONTACT
            </NavButton>
        </HStack>
    );
};

export default DesktopNavigation;